import React, { Suspense, useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useModalContext } from '@bcraft-frontend-lib/core'
import { Slot, SlotFrameMode, useFrameManager } from '@bcraft-frontend-lib/slots'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import withQueryParams from 'modules/SlotsRoot/components/SlotsLayout/withQueryParams'
import { SlotPlace } from 'modules/SlotsRoot/redefinitions'
import { IFiltersSlots } from 'modules/SlotsRoot/types/filters'

import { selectLocaleDict } from 'features/locale/selectors'

import SlotsLayoutContent from 'components/slots/SlotsLayoutContent'
import { Spinner } from 'components/Spinner'

import './SlotAddModal.scss'

interface ISlotAddModal {
  filters: IFiltersSlots
  path: string
}

interface ParamsMatch {
  demoStart: string
  order: string
  gameType: string
}

const b = block('slot-add-modal')

const SlotAddModal: React.FC<ISlotAddModal> = ({ path, filters }) => {
  const params = getRouteParamsByStrings<ParamsMatch>(MODAL_ROUTE_PATH.ADD_SLOT_FRAME, path)
  const locale = useSelector(selectLocaleDict, shallowEqual).slots
  const { setOpenedModals } = useModalContext()
  const { handleAddFrame } = useFrameManager()

  const addFrameHandler = useCallback(
    (slot: Slot) => () => {
      let mode: SlotFrameMode = 'money'
      if (params?.demoStart) {
        mode = 'demo'
      } else if (params?.gameType === 'free-spin') {
        mode = 'free-spin'
      }

      handleAddFrame({
        order: Number(params?.order),
        gameId: slot.id,
        mode,
      })
      setOpenedModals([])
    },
    [handleAddFrame, params?.demoStart, params?.gameType, params?.order, setOpenedModals],
  )

  return (
    <div className={b()}>
      <div className={b('title')}>{locale.addGame.slice(2)}</div>
      <Suspense fallback={<Spinner isLoading />}>
        <SlotsLayoutContent
          modal
          place={params?.gameType as SlotPlace}
          addFrame={addFrameHandler}
          filters={filters}
        />
      </Suspense>
    </div>
  )
}

export default withQueryParams(SlotAddModal)
